import { ClienteXCiudad } from "../../login/cliente_login";
import { ListaDiccionaryEntity } from "../../../components/common/utils/entities/lista_dictionary_entity";

export class ConsultaPoliza
    {
        constructor(
        public Segmento?: number,
        public SegmentoAlterno?: number,
        public Cliente?: ClienteXCiudad
        ){}
    }

export class PolizaEntity
    {
        constructor(
        public CodigoPoliza?: string,
        public CodigoCiudad?: number,
        public CodigoRamo?: string,
        public CodigoAseguradora?: number,
        public RolEmpleado?: number,
        public FecVigIni?: string,
        public FecVigFin?: string,
        public CodigoUnidad?: number,
        public CodigoCliente?: number,
        public PolizaDeclarativa?: boolean,
        public Opciones?: ListaDiccionaryEntity[],
        public NombreAseguradora?: string,
        public NombreRamo?: string,
        public Accion?: number,
        public CodigoPlan?: number,
        public Devolucion?: boolean,
        public EsObligatoria?: boolean,
        public Opcion?: number,
        public CodigoGrupo?: number,
        public CodigoTipoNegocio?: number,
        public Planes?: Planes[],
        public CodigoPolCmb?: number,
        public CodigoPlanCliente?: number,
        public Ramos?: number[],
        public CodigoPlanTitular?: number,
        public EmailTitular?:string,
        public TelefonoTitular?:string,
        public Respolcod?: number,
        public CodigoRubro?: number
        ){}

    }
    export class BusquedaSiniestralidad {
        constructor(
            public CodigoGrupo?: number,
            public CodigoCiudad?: number,
            public CodigoCliente?: number,
            public CodigoUnidad?: number,
            public CodigoRamo?: string,
            public CodigoPlan?: number,
            public FechaDesde?: Date,
            public FechaHasta?: Date,
            public CodigoTitular?: number,
            public TipoFecha?: number,
            public TopRegistros?: number,
            public CodigoTipoNegocio?: number,
            public CodigoAseguradora?: number,
            public AnioInicio?: number,
            public AnioFin?: number,
            public MesInicio?: number,
            public MesFin?: number,
            public Estado?: number,
            public Factura?: boolean,
            public CentroDeCosto?:boolean,
            public Ramos?: number[]
            
        ) {

        }

    }
    export class TitularVam {
        constructor(
            public CodigoCliente?: number,
            public CodigoCiudad?: number,
            public Cedula?: string,
            public FechaInicio?: string,
            public FechaFin?: string,
            public NombreTitular?: string
        ) { }
    }
    export class Planes {
        constructor(
            public  CodigoPlan?: number,
            public  NombrePlan?: string,
            public CodigoPlanCliente?: number
        ) {
        }

    }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/polizas_cliente_entity.ts